module.exports = __webpack_public_path__ + "img/image7.3c17c096.png";